import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import Icon from "@material-ui/core/Icon";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Router, Link, Redirect, navigate } from "@reach/router";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import red from "@material-ui/core/colors/red";
import { withSnackbar } from "notistack";

import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";
import UserProfileModal from "./UserProfileModal";
import { hasChildRoleOf, hasExactRole, hasExactRoleOf } from "../../../auth";
const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 2,
  },

  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  button: {
    margin: theme.spacing(1),
  },
  appbar: {
    marginBottom: 1,
  },
}));

//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//登陆后显示的菜单按钮
function MenuForLogin(props) {
  const { anchorEl, handleClick, handleClose } = props;
  const { account } = props;
  //UserProfileModal State
  const [open, handleClickOpen, handleModalClose] = useDialog();

  const handleLogout = (postUrl) => {
    return (e) => {
      let h = new Headers();
      h.append("Accept", "application/*");

      let req = new Request(postUrl, {
        method: "GET",
        headers: {
          Accept: "application/*, text/plain, */*",
        },
        mode: "cors",
        credentials: "include",
      });

      fetch(req)
        .then((res) => {
          //   console.log("fetch");
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.text();
        })
        .then((data) => {
          //   console.log(data);
          handleClose();
          //提交成功后的反馈SnackBar
          props.enqueueSnackbar("您已成功登出", {
            variant: "success",
          });
          store.dispatch({ type: "LOGOUT" });

          //退出登录同时情况storage里存储的vlabtoken
          if (window.localStorage.getItem("vlabToken")) {
            window.localStorage.removeItem("vlabToken");
          }
        })
        .catch((error) => {
          //失败后显示错误SnackBar
          console.log(error);
          handleClose();
          props.enqueueSnackbar("退出登录失败", {
            variant: "error",
          });
        });
    };
  };
  return (
    <div>
      <Typography variant="body1" color="secondary" component="span">
        {account.nickname}
        <IconButton onClick={handleClick} color="inherit">
          <ExpandMoreIcon />
        </IconButton>
      </Typography>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>身份：{account.role}</MenuItem>

        {!account.vlabToken && (
          <>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/grade/");
              }}
            >
              {hasChildRoleOf("学生") && "我的成绩"}
              {hasChildRoleOf("教师") && "成绩管理"}
            </MenuItem>

            {hasExactRoleOf(["教师", "学生"]) ? (
              <MenuItem
                onClick={() => {
                  handleClose();
                  handleClickOpen();
                }}
              >
                个人信息
              </MenuItem>
            ) : null}
          </>
        )}

        <MenuItem onClick={handleLogout(`${SERVER_ADDRESS}/api/logout/`)}>
          退出登录
        </MenuItem>
      </Menu>

      {/* Modal放在最外层避免Focus丢失 */}
      <UserProfileModal
        open={open}
        handleClose={handleModalClose}
        formTitle="修改个人信息"
      />
    </div>
  );
}

export default withSnackbar(MenuForLogin);
